import * as React from 'react';
import {ChangeEvent} from "react";
import {actionSetTabItem, actionSetTabState} from "../store/tabs/actions";
import {Utility} from "../core/Utility";
import {isObject} from "util";
import {type} from "os";

export interface BaseTabProps {
	item: any
	state: any
}

export interface BaseTabState {
}

abstract class BaseTab<P extends BaseTabProps, S extends BaseTabState> extends React.Component<P, S> {

	protected constructor(props: P) {
		super(props)
	}

	componentWillMount() {
	}

	componentDidMount() {
	}

	abstract render(): React.ReactNode

	protected handleChange(e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>, name: string) {

		let tabState = this.props.state
		tabState[name] = e.target.value
		actionSetTabState(tabState)
	}

	protected handleGenericInputChange(key: string, value: any) {
		let item: any = this.props.item
		let tabState = this.props.state
		if (!tabState['item']) tabState['item'] = Utility.clone(item)
		if (!tabState['item']['fields']) tabState['item']['fields'] = {}
		tabState['item']['fields'][key] = value
		actionSetTabState(tabState)
	}

	protected handleItemGenericInputChange(key: string, value: any) {
		let item: any = this.props.item
		let tabState = this.props.state
		if (!tabState['item']) tabState['item'] = Utility.clone(item)
		tabState['item'][key] = value
		actionSetTabState(tabState)
	}

	protected handleItemTextInputChange(e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>, key: string) {

		let item: any = this.props.item
		// item[name] = e.target.value
		// actionSetTabItem(item)

		let tabState = this.props.state
		if (!tabState['item']) tabState['item'] = Utility.clone(item)
		tabState['item'][key] = e.target.value
		actionSetTabState(tabState)
	}

	protected handleItemSelectChange(e: ChangeEvent<{ name?: string; value: unknown }>, name: string) {

		let item: any = this.props.item
		// item[name] = e.target.value
		// actionSetTabItem(item)

		let tabState = this.props.state
		if (!tabState['item']) tabState['item'] = Utility.clone(item)
		tabState['item'][name] = e.target.value
		actionSetTabState(tabState)
	}

	protected handleItemPermissionChange(permission: string | null, name: string) {
		let item: any = this.props.item
		let tabState = this.props.state
		if (!tabState['item']) tabState['item'] = Utility.clone(item)
		tabState['item'][name] = permission
		actionSetTabState(tabState)
	}

	protected handleItemRoleChange(role: string[] | null, previousRoles:any, activeDepartment:string, allRoles:any, allDepartments: any, name: string) {
		if (!Array.isArray(previousRoles)) previousRoles = []
		let newRoles:any[] = []
		if(previousRoles.length){
				for(let prevRole of previousRoles){
					if(prevRole.departmentId != activeDepartment && prevRole.departmentId != undefined){
						newRoles.push(prevRole) //copy existed roles for other departments
					} else {
						if(prevRole.departmentId == activeDepartment && prevRole.departmentId != undefined) {
							if(role!=[]){
								for(let itemOfRoles of role){ //update roles for curentDepartment
									for(let anyRoles of allRoles){
										if(anyRoles.name == itemOfRoles){
											newRoles.push({departmentId:activeDepartment, roleId:anyRoles.id})
										}
									}
								}
							}
						}
						else {
							if(prevRole.departmentId == undefined){
								if(activeDepartment!='all'){
									newRoles.push({roleId:prevRole.roleId})
								} else {
									if(role!=[]){
										for(let itemOfRoles of role){ //update roles for curentDepartment
											for(let anyRoles of allRoles){
												if(anyRoles.name == itemOfRoles){
													newRoles.push({roleId:anyRoles.id})
												}
											}
										}
									}
								}
							}
						}
					}
				}
				if(activeDepartment != 'all'){
					for(let itemOfRoles of role){ //create new roles for current department
						let foundedRole = false
						for(let anyPreviousRole of previousRoles){
							for(let anyRoles of allRoles){
								if(anyRoles.name == itemOfRoles && anyPreviousRole.departmentId == undefined && anyRoles.id == anyPreviousRole.roleId){
									foundedRole = true
								}
							}
						}
						if(foundedRole) continue
						for(let anyRoles of allRoles){
							if(anyRoles.name == itemOfRoles){
								newRoles.push({departmentId:activeDepartment, roleId:anyRoles.id})
							}
						}
					}
				}
				if(activeDepartment == 'all'){
					if(role!=[]){
						for(let itemOfRoles of role){ //update roles for curentDepartment
							for(let anyRoles of allRoles){
								if(anyRoles.name == itemOfRoles){
									newRoles.push({roleId:anyRoles.id})
								}
							}
						}
					}
				}
		} else {//previousRoles is empty
			for(let itemOfRoles of role){ //create new roles for current department
				for(let anyRoles of allRoles){
					if(activeDepartment == 'all'){
						if(anyRoles.name == itemOfRoles){
							newRoles.push({roleId:anyRoles.id})
						}
					} else {
						if(anyRoles.name == itemOfRoles){
							newRoles.push({departmentId:activeDepartment, roleId:anyRoles.id})
						}
					}

				}
			}
		}
		newRoles = newRoles.reduce((unique, o) => { //removed duplicated
			if(!unique.some((obj:any) => obj.departmentId === o.departmentId && obj.roleId === o.roleId)) {
				unique.push(o)
			}
			return unique
		},[])
		const newRolesWithoutAll = newRoles.filter(role => role.departmentId != "all")
		let jsonNewRoles=JSON.stringify(newRolesWithoutAll)
		let fixedJsonNewRoles = jsonNewRoles.replace(/\\/g, '')
		let item: any = this.props.item
		let tabState = this.props.state
		if (!tabState['item']) tabState['item'] = Utility.clone(item)
		tabState['item'][name] = fixedJsonNewRoles
		actionSetTabState(tabState)
	}

	protected handleItemDateChange (date: Date | null, name: string) {
		let item: any = this.props.item
		let tabState = this.props.state
		if (!tabState['item']) tabState['item'] = Utility.clone(item)
		tabState['item'][name] = date
		actionSetTabState(tabState)
	}

	protected getFromTabState (state: any, key: string, defaultValue?: string) {
		let value = defaultValue ? defaultValue  : ""
		if (state[key]) value = state[key]
		return value
	}

	protected getItemFromTabState (key?: string) {
		let tabState = this.props.state
		if (tabState['item']) {
			if (!key) return tabState['item']
			else if (!Utility.isNullOrUndefined(tabState['item'][key])) return tabState['item'][key]
		}
		if (!key) return this.props.item
		else if (this.props.item) return this.props.item[key]
		return null
	}

	protected getObjectItemFromTabState (key?: string) {
		let result = this.getItemFromTabState(key)
		var object = null
		if (typeof result == "string") {
			try {
				object = JSON.parse(result)
			} catch (e) {
				console.log(e)
			}
		} else {
			return result
		}
		return object
	}

	protected getGenericItemFromTabState (key?: string) {
		let tabState = this.props.state
		if (tabState['item']) {
			if (!key) return tabState['item']
			else if (!Utility.isNullOrUndefined(tabState['item']) && !Utility.isNullOrUndefined(tabState['item']['fields']) && !Utility.isNullOrUndefined(tabState['item']['fields'][key])) return tabState['item']['fields'][key]
		}
		if (!key) return this.props.item
		else if (this.props.item && this.props.item['fields']) return this.props.item['fields'][key]
		return null
	}

	protected getItemValueFromTabState (key: string) {
		let tabState = this.props.state
		if (tabState['item']) return tabState['item']
		return this.props.item
	}
}

export default BaseTab;
